// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__2-JFn","password":"PasswordResetForm_password__3Aqgo"};